import { useState } from "react";
import type { FullRecord, RecordInput } from "@shared/types";
import { api } from "../api";
import { useAuth } from "../auth/AuthContext";

interface Props {
  recordId: number;
  records: FullRecord[];
  onUpsert: (r: FullRecord) => void;
  onClose: () => void;
}

export function ReactivationModal({ recordId, records, onUpsert, onClose }: Props) {
  const auth = useAuth();
  const item = records.find(r => r.id === recordId);
  const [resp, setResp] = useState(item?.resp || "");
  const [obs, setObs] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!item) return null;

  async function confirm() {
    if (!item) return;
    setSubmitting(true);
    try {
      const payload: RecordInput = {
        cliente: item.cliente,
        status: "novo",
        resp: resp || item.resp || undefined,
        ramo: item.ramo || undefined,
        corretor: item.corretor || undefined,
        data: item.data || undefined,
        obs: obs || `Reativado em ${new Date().toLocaleString("pt-BR")}`,
        prox_data: "",
        prox_mot: "",
        motivo_perda: "",
        motivo_det: "",
        reativ_data: "",
      };
      const stage1 = await api.updateRecord(item.id, payload, item.version);
      if (stage1) {
        const histTxt = `${auth.user.display_name} reativou. ${item.motivo_perda ? "Motivo anterior: " + item.motivo_perda + "." : ""}${obs ? " " + obs : ""}`.trim();
        const stage2 = await api.addHistory(item.id, histTxt, stage1.record.version).catch(() => null);
        onUpsert(stage2?.record || stage1.record);
      }
      onClose();
    } catch (e: any) {
      alert("Erro ao reativar: " + (e.message || e));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="overlay open" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal-sm">
        <h2>Reativar prospecção</h2>
        <p className="sub">
          Cliente <strong>{item.cliente}</strong> ({item.ramo}) foi marcado para reativação.
        </p>
        {item.motivo_perda && (
          <div className="mpill">
            Não fechou por: {item.motivo_perda}{item.motivo_det ? " — " + item.motivo_det : ""}
          </div>
        )}
        <div className="fr"><label>Responsável</label><input type="text" placeholder="sintia, DAI..." value={resp} onChange={e => setResp(e.target.value)} /></div>
        <div className="fr"><label>Observação de abertura</label><textarea placeholder="Ex: retomar contato pelo WhatsApp, possível renovação de apólice" value={obs} onChange={e => setObs(e.target.value)} /></div>
        <div className="mfoot" style={{ marginTop: 16 }}>
          <button className="btn-cancel" onClick={onClose}>Cancelar</button>
          <button className="btn-save" onClick={confirm} disabled={submitting}>Reativar agora</button>
        </div>
      </div>
    </div>
  );
}
